<div class="headerFlexW pr-4 m-3">
    <div class="content-block">
        <p class="bread-crumbs">Usuarios / Perfil</p>
        <h2 class="">Usuarios</h2>
    </div>
</div>
<div class="content-block ">
    <div id="sideDetailsW">
        <div class="dx-card responsive-paddings sideDetailsView">
            <div class="sideDetailsAvatar mt-3 mb-3"><i class="fad fa-user-unlock fa-3x brand-color"></i></div>
            <div class="">
                <ul>
                    <li>Nombre: {{userData.name}} {{userData.middleName}} {{userData.lastName}}
                        {{userData.secondLastName}}</li>
                    <li>Email: {{userData.email}}</li>
                    <li>Tel: {{userData.phone}}</li>
                    <li># de empleado: {{userData.userNumber}}</li>
                    <li *ngIf="!userData.dateCreated == null">Fecha de alta: {{userData.dateCreated|numberToDate}}</li>
                    <li>Empresa: {{userData.companyName}}</li>
                </ul>
            </div>
            <div>
                <dx-button text="Cambiar contraseña" icon="email" type="default" (onClick)="resetPassword()"></dx-button>
            </div>
        </div>
        <div class="responsive-paddings dx-card sideDetailsForm">
            <form action="Edit Profile" [formGroup]="uploadForm" (submit)="onFormSubmit()">
                <dx-form [formData]="userData" id="form">
                    <dxi-item dataField="name">
                        <dxo-label text="Nombre"></dxo-label>
                        <dxi-validation-rule type="required" message="Campo requerido">
                        </dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="middleName">
                        <dxo-label text="Segundo nombre"></dxo-label>
                    </dxi-item>
                    <dxi-item dataField="lastName">
                        <dxo-label text="Apellido paterno"></dxo-label>
                        <dxi-validation-rule type="required" message="Campo requerido">
                        </dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="secondLastName">
                        <dxo-label text="Apellido materno"></dxo-label>
                        <dxi-validation-rule type="required" message="Campo requerido">
                        </dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="email">
                        <dxo-label text="Email"></dxo-label>
                        <dxi-validation-rule type="required" message="Campo requerido">
                        </dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="phone">
                        <dxo-label text="Teléfono"></dxo-label>
                        <dxi-validation-rule type="required" message="Campo requerido">
                        </dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="passport">
                        <dxo-label text="Pasaporte"></dxo-label>
                    </dxi-item>
                    <dxi-item dataField="ine">
                        <dxo-label text="INE"></dxo-label>
                    </dxi-item>
                    <dxi-item itemType="button" horizontalAlignment="right" [buttonOptions]="buttonOptions"
                        class="mt-2">
                    </dxi-item>
                </dx-form>
            </form>
        </div>
    </div>
</div>